<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section style="margin-bottom: 1%">
        <a-button type="primary" @click="goToAddPurchaseOrder(false)">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t(`form.PreArrivalNoticeEntry`) }}
        </a-button>
        <a-button type="primary" @click="showModalFn">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t(`form.BatchRecordOrders`) }}
        </a-button>
      </section>

      <a-row :gutter="16" style="display: flex; gap: 12px 0; flex-wrap: wrap">
        <a-col :span="6">
          <a-input
            allowClear
            v-model.trim="formData.advancedShippingNoteSn"
            allow-clear
            :placeholder="$t(`form.pleaseChoose`) + $t(`form.AdvancedShippingNotesNumber`)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allowClear
            v-model.trim="formData.associatedOrderSn"
            allow-clear
            :placeholder="$t(`form.PleaseEnter`) + $t(`form.AssociatedDocNo`)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allowClear
            v-model.trim="formData.receivingOrderSn"
            allow-clear
            :placeholder="$t(`form.ReceivingOrderNumber`)"
          />
        </a-col>
        <a-col :span="6">
          <date-range-picker
            allowClear
            id="effectiveTime"
            :needhms="false"
            @get_date="chooseOrderStart"
            :placeholder="$t(`form.OrderTime`)"
            :start-time="formData.estimatedArrivalTimeStart"
            :end-time="formData.estimatedArrivalTimeEnd"
          ></date-range-picker>
        </a-col>
        <a-col :span="6">
          <!-- 仓库名称选项 -->
          <SelectWarehouseNew
            :placeholder="$t(`form.warehouseName`) + '（' + $t(`form.SingleChoice`) + '）'"
            style="width: 100%"
            :code.sync="formData.warehouseCode"
            @change="chooseWarehouse"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.barcode"
            @pressEnter="queryOrderList(1)"
            :placeholder="$t(`form.PleaseEnter`) + $t(`form.ProductBarcode`)"
          />
        </a-col>
        <a-col :span="6">
          <a-select
            allowClear
            :placeholder="$t(`form.pleaseChoose`) + $t(`form.Source`)"
            style="width: 100%"
            v-model="formData.asnType"
          >
            <a-select-option :key="0" value="PURCHASE">
              {{ $t(`form.purchase`) }}
            </a-select-option>
            <a-select-option :key="1" value="TRANSFER">
              {{ $t(`form.Transfer`) }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.batchNo"
            @pressEnter="queryOrderList(1)"
            :placeholder="$t(`form.PleaseEnter`) + $t(`form.BatchNo`)"
          />
        </a-col>
        <a-col :span="6" v-if="isRent">
          <a-input
            allow-clear
            v-model.trim="formData.imei"
            @pressEnter="queryOrderList(1)"
            placeholder="IMEI"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="queryOrderList(1)" class="btnBgc">
            <i class="iconfont">&#xe647;</i>
            {{ $t(`form.Search`) }}
          </a-button>
          <a-button @click="onExport" style="margin-left: 15px">
            <i class="icon iconfont icon-upload"></i>
            {{ $t(`form.Export`) }}
          </a-button>
        </a-col>
      </a-row>
      <div class="table-content">
        <div class="table-header">
          <div class="row status-list-wrap">
            <input type="hidden" v-model="formData.status" />
            <a-tabs default-active-key="" @change="setSearchStatus">
              <a-tab-pane key="">
                <template slot="tab">
                  <span>{{ $t('form.All') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="WAIT_CHECK">
                <template slot="tab">
                  <span>{{ $t('form.Pending') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="WAIT_PUSH">
                <template slot="tab">
                  <span>{{ $t('form.WAIT_PUSH') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="WAIT_INBOUND">
                <template slot="tab">
                  <span>{{ $t('form.WAIT_INBOUND') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="PART_INBOUND">
                <template slot="tab">
                  <span>{{ $t('form.PART_INBOUND') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="FINISH">
                <template slot="tab">
                  <span>{{ $t('form.FINISH') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="CANCEL">
                <template slot="tab">
                  <span>{{ $t('form.Abolished') }}</span>
                </template>
              </a-tab-pane>
              <a-tab-pane key="PUSH_FAIL">
                <template slot="tab">
                  <span>{{ $t('form.PushFailed') }}</span>
                </template>
              </a-tab-pane>
            </a-tabs>
          </div>
          <ul class="action-list" v-show="tableData.length">
            <!-- 批量审核 -->
            <li style="margin-right: 15px">
              <a-button class="btnBgc" @click="batchCheck">
                {{ $t(`form.Review`) }}
              </a-button>
            </li>
            <!-- 批量作废 -->
            <li style="margin-right: 15px">
              <a-button class="btnBgD" @click="batchCancel">
                {{ $t(`form.Void`) }}
              </a-button>
            </li>
            <!-- 创建应付单 -->
            <li style="margin-right: 15px" v-if="hasFMSApp">
              <a-button class="btnBgc" @click="batchCreatePayable">
                {{ $t(`创建应付单`) }}
              </a-button>
            </li>
            <!-- 批量完结 -->
            <!-- <li style="margin-right: 15px">
              <a-button class="btnBgc" @click="batchFinish">
                {{ $t(`form.ConfirmFinish`) }}
              </a-button>
            </li> -->
            <!-- 手动推送 -->
            <!-- <li style="margin-right: 15px">
              <a-button class="btnBgc" @click="batchRetryPushAsn">
                {{ $t(`form.shoudongts`) }}
              </a-button>
            </li> -->
          </ul>
        </div>
        <div class="table-body">
          <a-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
            }"
            :columns="tableColumns"
            :data-source="tableData"
            rowKey="advancedShippingNoteId"
            :pagination="false"
            :scroll="{ x: 1500 }"
            :expandedRowKeys="expandedRowKeys"
            @change="headerOperation"
            @expand="handleExpand"
            bordered
          >
            <template slot="advancedShippingNoteSn" slot-scope="text, record">
              <a @click="onCliCkDetail(record.advancedShippingNoteId)">
                {{ record.advancedShippingNoteSn }}
              </a>
            </template>
            <template slot="time" slot-scope="text, record">
              <div>
                <div class="time-item">{{ $t('form.CreateAt') }}：{{ record.orderTime }}</div>
                <div class="time-item" v-if="record.finishTime">
                  {{ $t('form.ReceivingCompletionTime') }}：{{ record.finishTime }}
                </div>
              </div>
            </template>
            <!-- 入库数量 -->
            <template slot="TotalCount" slot-scope="text, record">
              {{ record.totalCount | toThousands }}
            </template>
            <!-- 当前入库 -->
            <template slot="NowCount" slot-scope="text, record">
              {{ record.nowCount | toThousands }}
            </template>
            <!-- 差异数量 -->
            <template slot="DifferentCount" slot-scope="text, record">
              {{ record.differentCount | toThousands }}
            </template>
            <!-- 来源 -->
            <template slot="Source" slot-scope="text, record">
              {{ record.asnType | asnTypeFilter }}
            </template>
            <!-- 调拨信息 -->
            <template slot="TransferOrderInfo" slot-scope="text, record">
              <div v-if="hasTransferInfo(record)">
                <div class="transfer-item">
                  {{ $t('form.StockTransferNo') }}：{{
                    record.transferOrder.transferOrderSn || '-'
                  }}
                </div>
                <div class="transfer-item">
                  {{ $t('form.ShippingWarehouse') }}：{{
                    record.transferOrder.outboundWarehouseName || '-'
                  }}
                </div>
                <!-- <div class="transfer-item">
                  {{ $t('form.WarehouseDeliveryOrderNo') }}：{{
                    record.transferOrder.outboundOrderSn || '-'
                  }}
                </div> -->
                <div class="transfer-item">
                  {{ $t('form.TransferOrderCreator') }}：{{
                    formatTransferUser(record.transferOrder.createdUser)
                  }}
                </div>
                <div class="transfer-item">
                  {{ $t('form.TransferOrderRemark') }}：{{ record.transferOrder.note || '-' }}
                </div>
              </div>
              <span v-else>-</span>
            </template>
            <template slot="expandedRowRender" slot-scope="record">
              <a-table
                :columns="innerColumns"
                :data-source="record.items || []"
                :loading="record.detailLoading"
                :pagination="false"
                :row-class-name="innerRowClassName"
                size="small"
                bordered
                rowKey="advancedShippingNoteItemId"
              >
                <template slot="innerSentQuantity" slot-scope="text">
                  {{ text | toThousands }}
                </template>
                <template slot="purchaseUnitPrice" slot-scope="text, record2">
                  <PriceInput
                    :value="text"
                    :showTxt="true"
                    :currency="record2.currency"
                    v-if="text !== undefined"
                  />
                  <span v-else>-</span>
                </template>
                <template slot="innerPutAwayQuantity" slot-scope="text">
                  {{ text | toThousands }}
                </template>
                <template slot="innerPutAwayDefectiveQuantity" slot-scope="text">
                  {{ text | toThousands }}
                </template>
                <template slot="innerDifferentCount" slot-scope="text, innerRecord">
                  {{ getInnerDiffCount(innerRecord) }}
                </template>
              </a-table>
            </template>
          </a-table>
        </div>
        <div class="table-footer">
          <pagination
            :pageNo="pageNo"
            :length="pageSize"
            :total-count="total"
            @paginate="paginate"
          ></pagination>
        </div>
      </div>
    </section>
    <!-- 导入盘点数据 -->
    <a-modal
      class="importModal"
      v-model="isImportData"
      :title="modalInfo.modalTitle"
      :width="500"
      :footer="null"
    >
      <div class="upload-content">
        <a-upload-dragger
          name="file"
          :headers="{ Authorization: sessionId }"
          :data="{ buId: buId }"
          @change="importData"
          :action="modalInfo.modalUrl + `?language=${this.language_mapping[this.lang]}`"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="cloud-upload" />
          </p>
          <p class="ant-upload-hint">{{ $t('form.DragUpload') }}</p>
        </a-upload-dragger>
        <a
          v-if="modalInfo.xlsDownloadUrl"
          class="text-info mt10"
          download
          :href="modalInfo.xlsDownloadUrl"
        >
          {{ modalInfo.modalTitle }}{{ $t('form.Template') }}.xls
        </a>
      </div>
    </a-modal>
  </div>
</template>
<script>
import http from '@/service/axios'
import api from '@/service/api'
import { mapMutations, mapGetters } from 'vuex'
import pagination from '@component/pagination'
import dateRangePicker from '@component/dateRangePicker'
import { Modal } from 'ant-design-vue'
import { getCookie } from '@/common/cookie'
import fetch from '@/service/fetch'
import PriceInput from '@component/priceInput'
import SelectWarehouseNew from '@component/selectWarehouseNew'
var _self = {}
export default {
  name: 'advancedShippingNote',
  mounted() {
    _self = this
    this.queryOrderList()
    this.sessionId = getCookie('d_session_id')
    let currentShop = JSON.parse(localStorage.getItem('currentShop'))
    this.shopCode = currentShop.uniqueCode
  },
  activated() {
    this.queryOrderList()
  },
  components: {
    pagination,
    dateRangePicker,
    PriceInput,
    SelectWarehouseNew,
  },
  data() {
    return {
      shopCode: '',
      status: '',
      formData: {},
      pageNo: 1,
      pageSize: 10,
      orderByParam: 'created_at DESC',
      total: 0,
      selectedRowKeys: [],
      expandedRowKeys: [],
      tableData: [],
      visible: false,
      isImportData: false,
      modalInfo: {
        modalTitle: this.$t('form.BatchRecordOrders'),
        modalDesc: this.$t('form.AddProductNote'),
        modalUrl: api.advancedShippingNotebatchSave,
        xlsRequestUrl: '',
        xlsDownloadUrl: '',
      },
      sessionId: '',
      language_mapping: {
        zh: 'zh_CN',
        en: 'en_US',
        th: 'th_TH',
      },
    }
  },
  computed: {
    ...mapGetters(['isRent']),
    tableColumns() {
      const list = [
        {
          dataIndex: 'advancedShippingNoteSn',
          title: this.$t(`form.AdvancedShippingNotesNumber`),
          key: 'advancedShippingNoteSn',
          scopedSlots: { customRender: 'advancedShippingNoteSn' },
          width: 180,
        },
        {
          title: this.$t('时间'),
          dataIndex: 'time',
          width: 260,
          scopedSlots: { customRender: 'time' },
        },
        {
          dataIndex: 'associatedOrderSn',
          title: this.$t(`form.AssociatedDocNo`),
          key: 'associatedOrderSn',
          width: 180,
        },
        {
          dataIndex: 'batchNo',
          title: this.$t(`form.BatchNo`),
          key: 'batchNo',
          width: 160,
        },
        {
          title: this.$t(`form.ReceivingOrderNumber`),
          dataIndex: 'receivingOrderSn',
          key: 'receivingOrderSn',
          width: 160,
        },
        {
          title: this.$t(`form.status`),
          dataIndex: 'status',
          key: 'status',
          width: 150,
          customRender: (text) => this.getStatus(text),
        },
        {
          title: this.$t(`form.totalCount`),
          dataIndex: 'totalCount',
          key: 'totalCount',
          width: 120,
          scopedSlots: { customRender: 'TotalCount' },
        },
        {
          title: this.$t(`form.nowCount`),
          dataIndex: 'nowCount',
          key: 'nowCount',
          width: 120,
          scopedSlots: { customRender: 'NowCount' },
        },
        {
          title: this.$t(`form.differentCount`),
          dataIndex: 'differentCount',
          key: 'differentCount',
          width: 120,
          scopedSlots: { customRender: 'DifferentCount' },
        },
        {
          title: this.$t(`form.SupplierName`),
          key: 'supplierName',
          width: 150,
          dataIndex: 'supplierName',
        },
        {
          title: this.$t(`form.warehouseName`),
          key: 'warehouseName',
          width: 160,
          dataIndex: 'warehouseName',
        },
        {
          title: this.$t(`form.Source`),
          key: 'asnType',
          dataIndex: 'asnType',
          width: 120,
          scopedSlots: { customRender: 'Source' },
        },
        {
          title: this.$t(`form.TransferInformation`),
          key: 'transferOrder',
          dataIndex: 'transferOrder',
          width: 220,
          scopedSlots: { customRender: 'TransferOrderInfo' },
        },
        {
          title: this.$t('form.Remark'),
          key: 'note',
          width: 120,
          dataIndex: 'note',
        },
        {
          title: this.$t('创建人'),
          key: 'createdUser',
          dataIndex: 'createdUser',
          width: 120,
          customRender: (text) => decodeURIComponent(text),
        },
      ]
      if (this.isRent) {
        return list.filter(
          (col) => col.dataIndex !== 'batchNo' && col.dataIndex !== 'receivingOrderSn'
        )
      }
      return list
    },
    statusListTop() {
      return [
        {
          statusName: this.$t(`form.All`), //全部
          status: '',
        },
        {
          statusName: this.$t(`form.Enabled`), //"已启用",
          status: 'open',
        },
        {
          statusName: this.$t(`form.NotActive`), //"未激活",
          status: 'close',
        },
        {
          statusName: this.$t(`form.Deleted`), //已删除,
          status: 'delete',
        },
      ]
    },
    lang() {
      return this.$store.state.lang
    },
    buId() {
      console.log(this.$store.getters.partyId)
      return this.$store.getters.partyId
    },
    hasFMSApp() {
      let currentIdaasApp = JSON.parse(localStorage.getItem('currentIdaasApp') || '{}')
      return !!currentIdaasApp['FMS']
    },
    innerColumns() {
      return [
        {
          title: this.$t('form.BoxNumber'),
          dataIndex: 'caseNo',
          key: 'caseNo',
          width: 100,
        },
        {
          title: this.$t('form.ProductName'),
          dataIndex: 'productName',
          key: 'productName',
          width: 180,
        },
        {
          title: this.$t('form.skuNumber'),
          dataIndex: 'skuNumber',
          key: 'skuNumber',
          width: 150,
        },
        {
          title: this.$t('form.ProductBarcode'),
          dataIndex: 'barcode',
          key: 'barcode',
          width: 150,
        },
        {
          title: this.$t('单价'),
          dataIndex: 'purchaseUnitPrice',
          key: 'purchaseUnitPrice',
          width: 150,
          scopedSlots: {
            customRender: 'purchaseUnitPrice',
          },
        },
        {
          title: this.$t('form.StockQuantity'),
          dataIndex: 'sentQuantity',
          key: 'sentQuantity',
          width: 100,
          scopedSlots: { customRender: 'innerSentQuantity' },
        },
        {
          title: this.$t('已入库(正品)'),
          dataIndex: 'putAwayQuantity',
          key: 'putAwayQuantity',
          width: 120,
          scopedSlots: { customRender: 'innerPutAwayQuantity' },
        },
        {
          title: this.$t('已入库(次品)'),
          dataIndex: 'putAwayDefectiveQuantity',
          key: 'putAwayDefectiveQuantity',
          width: 120,
          scopedSlots: { customRender: 'innerPutAwayDefectiveQuantity' },
        },
        {
          title: this.$t('form.differentCount'),
          dataIndex: 'differentCount',
          key: 'differentCount',
          width: 100,
          scopedSlots: { customRender: 'innerDifferentCount' },
        },
        {
          title: this.$t('form.Unit'),
          dataIndex: 'unit',
          key: 'unit',
          width: 80,
        },
        {
          title: this.$t('form.Remark'),
          dataIndex: 'note',
          key: 'note',
          width: 150,
        },
      ]
    },
  },
  filters: {
    asnTypeFilter(val) {
      const asnTypeMap = {
        PURCHASE: _self.$t(`form.purchase`),
        TRANSFER: _self.$t(`form.Transfer`),
      }
      return asnTypeMap[val]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    getStatus(text) {
      return this.$t(`form.${text}`)
    },
    // 仅调拨来源且存在关联调拨单时展示调拨信息
    hasTransferInfo(record) {
      return record.asnType === 'TRANSFER' && !!record.transferOrder
    },
    formatTransferUser(user) {
      if (!user) return '-'
      try {
        return decodeURIComponent(user)
      } catch (e) {
        return user
      }
    },

    chooseWarehouse(value) {
      //选择仓库
      if (value) {
        this.formData.warehouseCode = value
      } else {
        this.formData.warehouseCode = ''
      }
    },
    onCliCkDetail(id) {
      this.$router.push({
        name: 'advancedShippingNoteDetail',
        query: { id },
      })
    },
    selectedWarehouse(data) {
      if (data.warehouseId) {
        this.formData.warehouseId = data.warehouseId
      } else {
        this.formData.warehouseId = ''
      }
    },
    chooseOrderStart(date) {
      this.formData.estimatedArrivalTimeStart = date.start_time
      this.formData.estimatedArrivalTimeEnd = date.end_time
    },
    onExport() {
      if (!this.selectedRowKeys.length) {
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t(`form.ChooseArrivalNotice`),
        })
        return
      }
      fetch(api.advancedShippingNoteExport + `?language=${this.language_mapping[this.lang]}`, {
        method: 'POST',
        body: {
          advancedShippingNoteIds: this.selectedRowKeys,
          shopCode: this.shopCode,
        },
      }).then((res) => {
        if (res.result.taskId) {
          this.$message.success(this.$t('创建导出任务成功,请前往【数据中心/下载中心】下载'))
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    goToAddPurchaseOrder() {
      this.$router.push('addAdvancedShippingNote')
    },
    queryOrderList(first_page = false) {
      first_page && (this.pageNo = 1)
      this.expandedRowKeys = []
      this.$nextTick(() => {
        let data = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          advancedShippingNoteSn: this.formData.advancedShippingNoteSn,
          associatedOrderSn: this.formData.associatedOrderSn,
          estimatedArrivalTimeStart: this.formData.estimatedArrivalTimeStart,
          estimatedArrivalTimeEnd: this.formData.estimatedArrivalTimeEnd,
          warehouseCode: this.formData.warehouseCode,
          receivingOrderSn: this.formData.receivingOrderSn,
          barcode: this.formData.barcode,
          imei: this.formData.imei,
          orderByParam: this.orderByParam,
          asnType: this.formData.asnType,
          batchNo: this.formData.batchNo,
        }
        if (this.formData.status !== -1) {
          data.status = this.formData.status
        }

        http({
          instance: this,
          type: 'post',
          url: api.advancedShippingNote,
          hasLoading: true,
          data,
          success: (res) => {
            let advancedShippingNoteList = [...(res.result.advancedShippingNoteList || '')]
            this.tableData = advancedShippingNoteList
            this.total = res.result.total
          },
        })
      })
    },
    setSearchStatus(status) {
      this.$set(this.formData, 'tag', '')
      this.$set(this.formData, 'status', status)
      this.queryOrderList(1)
      this.selectedRowKeys = []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    // 排序
    headerOperation(pagination, filters, sorter = {}) {
      const { columnKey, order } = sorter
      if (columnKey === 'OrderTime') {
        console.log(sorter)
        this.orderByParam = order === 'ascend' ? 'created_at ASC' : 'created_at DESC'
        this.queryOrderList()
      }
    },
    batchCheck() {
      this.batchHandle({
        modalAction: this.$t('form.Review'),
        url: api.advancedShippingNoteBatchCheck,
      })
    },
    batchCancel() {
      if (this.isRent) {
        const hasRentTransfer = this.tableData.some(
          (item) =>
            this.selectedRowKeys.includes(item.advancedShippingNoteId) &&
            item.asnType === 'TRANSFER'
        )
        if (hasRentTransfer) {
          Modal.warning({
            title: this.$t('form.Tips'),
            content: this.$t('该单据为调拨单，暂不支持作废'),
          })
          return
        }
      }
      this.batchHandle({
        modalAction: this.$t('form.Void'),
        url: api.advancedShippingNoteBatchCancel,
      })
    },
    batchCreatePayable() {
      this.batchHandle({
        modalAction: this.$t('创建应付单'),
        url: api.batchCreatePayable,
        key: 'asnIdList',
      })
    },
    batchFinish() {
      this.batchHandle({
        modalAction: this.$t('form.ConfirmFinish'),
        url: api.advancedShippingNoteBatchFinish,
      })
    },
    batchRetryPushAsn() {
      this.batchHandle({
        modalAction: this.$t('form.shoudongts'),
        url: api.batchRetryPushAsn,
      })
    },
    confirmSelect() {
      let is_empty = false
      if (this.selectedRowKeys.length === 0) {
        is_empty = true
        this.$warning({
          title: this.$t(`layer.Warning`),
          content: this.$t('layer.SelectAtLeastOneItem'),
        })
      }
      return is_empty
    },
    batchHandle({ modalAction, url, key = 'advancedShippingNoteIds' }) {
      if (this.confirmSelect()) return
      Modal.confirm({
        title: this.$t('form.Tips'),
        content: `${this.$t('form.Whether')}${modalAction}${this.$t('form.SelectOrder')}`,
        okText: this.$t('form.Confirm'),
        cancelText: this.$t('form.Cancel'),
        onOk: () => {
          let data = {}
          data[key] = [...this.selectedRowKeys]
          this.commonHttp({
            url,
            modalAction,
            data,
          }).then(() => {
            this.queryOrderList()
          })
        },
      })
    },
    commonHttp({ url, modalAction, data }) {
      return new Promise((resolve) => {
        http({
          instance: this,
          type: 'post',
          hasLoading: true,
          url,
          data,
          success: (res) => {
            if (res.result && res.result.failPushedMsgs) {
              this.$error({
                title: this.$t(`form.Error`),
                content: `${res.result.failPushedMsgs}`,
              })
            } else {
              this.$success({
                title: this.$t(`form.Success`),
                content: `${modalAction}${this.$t('form.FINISH')}`,
              })
            }
            resolve(res)
          },
        })
      })
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryOrderList()
    },
    showModalFn() {
      this.isImportData = true
      this.modalInfo.xlsDownloadUrl =
        this.$i18n.locale == 'zh'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/advancedShippingNote/%E9%A2%84%E5%88%B0%E8%B4%A7%E9%80%9A%E7%9F%A5%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx' //模板下载链接"
          : this.$i18n.locale == 'en'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/advancedShippingNote/AdvanceShippingNoteTemplate.xlsx'
          : this.$i18n.locale == 'th'
          ? 'https://geez-prod.oss-cn-shanghai.aliyuncs.com/template/advancedShippingNote/AdvanceShippingNoteTemplate.xlsx'
          : ''
    },
    // 导入数据
    importData(info) {
      console.log(info)
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response.success) {
          this.$success({
            title: this.$t(`layer.Success`),
            content: `${info.file.name} file uploaded successfully.`,
          })
        } else {
          this.$error({
            title: this.$t(`form.Error`),
            content: `${info.file.response.msg} file upload failed.`,
          })
        }
      } else if (status === 'error') {
        this.$error({
          title: this.$t(`form.Error`),
          content: `${info.file.name} file upload failed.`,
        })
      }
      this.isImportData = false
    },
    async handleExpand(expanded, record) {
      if (expanded) {
        this.expandedRowKeys.push(record.advancedShippingNoteId)
        if (record.items && record.items.length) {
          return
        }
        this.$set(record, 'detailLoading', true)
        try {
          let res = await http({
            url: api.advancedShippingNoteDetail,
            type: 'post',
            data: {
              advancedShippingNoteId: record.advancedShippingNoteId,
            },
          })
          if (res && res.success && res.result) {
            this.$set(record, 'items', res.result.advancedShippingNoteItemResVOS || [])
          } else {
            this.$set(record, 'items', [])
          }
        } catch (e) {
          console.error(e)
          this.$set(record, 'items', [])
        } finally {
          this.$set(record, 'detailLoading', false)
        }
      } else {
        const index = this.expandedRowKeys.indexOf(record.advancedShippingNoteId)
        if (index > -1) {
          this.expandedRowKeys.splice(index, 1)
        }
      }
    },
    getInnerDiffCount(innerRecord) {
      const putAwayDefectiveQuantity = Number(innerRecord.putAwayDefectiveQuantity || 0)
      const putAwayQuantity = Number(innerRecord.putAwayQuantity || 0)
      const sentQuantity = Number(innerRecord.sentQuantity || 0)
      const num = putAwayDefectiveQuantity + putAwayQuantity - sentQuantity
      return num > 0 ? `+${num}` : num
    },
    innerRowClassName(record) {
      const receivedQuantity =
        record.receivedQuantity !== undefined
          ? record.receivedQuantity
          : Number(record.putAwayQuantity || 0) + Number(record.putAwayDefectiveQuantity || 0)
      return Number(receivedQuantity) !== Number(record.sentQuantity) ? 'highlight-row' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css/mixin.scss';
.btnBgc {
  background-color: #0088ff;
  color: #ffffff;
}
.btnBgD {
  background-color: #ff4d4f;
  color: #ffffff;
}
.batchBgc {
  color: #0088ff;
  border-color: #0088ff;
}
.action-list {
  display: flex;
}
.flex-btns {
  max-width: 120px;
  &.flex {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  .t-btn {
    cursor: pointer;
    margin-right: 10px;
    color: $primary-color;
    white-space: nowrap;
  }
}
.upload-content {
  padding: 20px;
}
.mt10 {
  margin-top: 10px;
  display: block;
}
.time-item {
  font-size: 13px;
}
.transfer-item {
  font-size: 13px;
  line-height: 20px;
  word-break: break-all;
}
::v-deep .highlight-row td {
  background-color: #fffbe6 !important;
}
</style>
